import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import Modal from "./modules/frontv2/Modal";
import Wish from "./modules/frontv2/Wish";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { getUserLanguage } from "./modules/utils";
import { initDrops } from "./modules/common/drop";
import { initScroll } from "./modules/scrolling";
import { initAutocomplete } from "./modules/frontv2/Autocomplete";
import { initMobileMenu } from "./modules/common/mobile-menu";
import { initScrollInto } from "./modules/common/scroll-into";
import { initFormValidation } from "./modules/common/form-validation";
import { initMessages } from "./modules/common/message";
import { initGoogleEcommerce } from "./modules/google_ecommerce";
import { initCommon } from "./modules/common/common";
import { initMaplibre } from "./modules/frontv2/Maplibre";
import { initCollapsible } from "./modules/collapsible";
import ReviewsFiltering from "./modules/frontv2/ReviewsFiltering";
import MobileMenu from "./modules/frontv2/MobileMenu";
import { initSwiper } from "./modules/common/init-swiper";
import { initSeeMoreContent } from "./modules/frontv2/seeMoreContent";
import { initBusinessDeletionRequest, initRecommendWinalistButton } from "./modules/frontv2/virtual-host-utils";
import BookDrawer from "./modules/frontv2/BookDrawer";
import { initCopyLinkToClipboard } from "./modules/common/init-copy-link-to-clipboard";
import SessionFilters from "./modules/frontv2/SessionFilters";
import { initHostScrollNavbar } from "./modules/frontv2/HostScrollNavbar";
import playVideoCover from "./modules/frontv2/init-video-cover-host";
// import { initCopyContent } from "./modules/frontv2/Host/init-copy-content";
import WinalistBusiness from "./modules/frontv2/WinalistBusiness";
// import { initLightboxLinker } from "./modules/common/gallery-lightbox-linker";

document.addEventListener('DOMContentLoaded', () => {
  // Init Sentry JS
  // if(document.body.dataset.env === 'prod') {
  //   sentryInit({ dsn: 'https://b14c92e307604f4f8f454ebdd3eab1ef@sentry.io/1441102' });
  // }

  flatpickr.localize(flatpickrLanguages[getUserLanguage()]);

  //common stuff
  initCommon();

  //Dropdowns and dropups
  initDrops();

  //Modal popups
  Modal.bindAllModals();

  //Header bar scroll logic
  initScroll();

  //Search bar logic (algolia)
  initAutocomplete();

  //Mobile menu
  initMobileMenu();

  initScrollInto();

  //Init mobile search
  new MobileMenu();

  //Init wish add/remove buttons
  Wish.bindWishButtons();

  initFormValidation();

  //Analytics
  initGoogleEcommerce();

  tippy('[data-tippy-content]', {
    theme: 'light'
  });

  initMaplibre();

  initCollapsible();

  //Handle AJAX Reviews Pagination
  new ReviewsFiltering();

  initSeeMoreContent();

  //for virtual host page
  initRecommendWinalistButton();
  initBusinessDeletionRequest();

  //Custom flash messages
  initMessages();

  // Swiper logic for sliders
  initSwiper();

  // Booking form drawer that appears on "Book now" click on the experience cards
  new BookDrawer();

  // Copy link to share Host
  initCopyLinkToClipboard();

  //init the session filters on the navbar
  new SessionFilters();

  //init the host navbar that appears on scroll
  initHostScrollNavbar();

  //init the video cover
  playVideoCover();

  //copy content from the description to the about block
  //prevent Google from finding duplicate content
  // initCopyContent();

  //logic for the winalist business block (to send quotes)
  new WinalistBusiness();

  //Lightbox linker
  // initLightboxLinker();
});
